import { Navigate } from 'react-router-dom'
import { useUsageTracking } from 'app/components/usage-tracking/useUsageTracking'
import { UsageTrackingComponent } from 'app/components/usage-tracking/UsageTrackingComponent'
import { useUser } from 'app/utils'

// Inner component holds the data hook so its query (opsUsageCostMetrics is
// super-only on the API) only ever fires once we've confirmed the user is a
// super user.
function UsageTrackingContent() {
  const hookData = useUsageTracking()
  return <UsageTrackingComponent {...hookData} />
}

export default function UsageTracking() {
  const user = useUser()

  if (!user) return null

  // The /ops layout redirects non-super users, but only from a useEffect —
  // the first render still mounts children, which would fire the super-only
  // opsUsageCostMetrics query. Guard synchronously here so the query never
  // fires for non-super users.
  if (user.type !== `super`) {
    return <Navigate to="/" replace />
  }

  return <UsageTrackingContent />
}
